import React, { useState } from 'react';
import InfoRequestModal from './InfoRequestModal';

const AboutKiloterra = () => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    console.error('Failed to load image: /Land Sales Agent In Field.jpg');
    setImageError(true);
  };

  return (
    <>
      <section id="about" className="py-20 relative overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          {!imageError ? (
            <img
              src="/Land Sales Agent In Field.jpg"
              alt="Land sales agent in the field"
              className="w-full h-full object-cover"
              loading="lazy"
              onError={handleImageError}
            />
          ) : (
            <div 
              className="w-full h-full"
              style={{ background: 'linear-gradient(135deg, #3A3A3A 0%, #5A5A5A 100%)' }}
            />
          )}
          <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center animate-slide-up">
            <h2 className="text-4xl font-bold text-white mb-6 uppercase">
              About KILOTERRA
            </h2>
            {/* Yellow horizontal line */}
            <div className="flex justify-center mb-6">
              <div className="w-16 h-1 bg-kiloterra-yellow"></div>
            </div>
            <p className="text-lg text-gray-200 mb-8 leading-relaxed max-w-4xl mx-auto">
              KILOTERRA isn't your average land brokerage. Our agents are a team of professionals who know land and take pride in doing things right. We work hard, chase big goals, and live with purpose.
            </p>
            <p className="text-lg text-gray-200 mb-8 leading-relaxed max-w-4xl mx-auto">
              At KILOTERRA, you'll find more than a career—you'll find a true sense of belonging. Here, you're supported to achieve freedom, earn a great income, and gain the time to pursue your passions. If you're ready for real opportunity with one of the Midwest's premier land brokerages, this is your shot.
            </p>

            <button 
              onClick={() => setIsInfoModalOpen(true)}
              className="bg-kiloterra-yellow text-kiloterra-dark px-8 py-4 font-bold hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 uppercase tracking-wide"
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      <InfoRequestModal 
        isOpen={isInfoModalOpen} 
        onClose={() => setIsInfoModalOpen(false)} 
      />
    </>
  );
};

export default AboutKiloterra;